module.exports = __webpack_public_path__ + "img/friends-zana-sm.9e97c74d.png";